//
// See documentation about Optanon Cookie Categories below

import { VideoCookiePolicyData } from '@rsa-digital/evo-shared-components/commonTypes/video';
import VideoCookieNotice from 'components/VideoCookieNotice';

export const getRequiredOptanonCategories = (url: string): string | undefined => {
  if (!url) {
    return undefined;
  }
  const isYouTubeVideo = url.includes('youtube.com') || url.includes('youtu.be');
  return isYouTubeVideo ? 'C0005' : undefined; // C0005 is the Optanon category for marketing cookies
};

export const getVideoCookiePolicyData = (
  url: string
): VideoCookiePolicyData | undefined => {
  const requiredOptanonCategories = getRequiredOptanonCategories(url);

  return requiredOptanonCategories
    ? {
        optanonRequiredConsentCategories: requiredOptanonCategories,
        CookieNoticeComponent: VideoCookieNotice,
      }
    : undefined;
};

// ------------------------------------------
// Documentation about Optanon Categories
// ------------------------------------------
//
// YouTube videos place Social Media cookies (Optanon Category C0005) in the
// browser. To comply with privacy regulations we need to require acceptance of
// such cookies from the user to enable the display and playback functionality
// of YouTube videos.
//
// RSA BW Ticket References:
// https://jira2.uk.rsa-ins.com/browse/CDS-326
// https://jira2.uk.rsa-ins.com/browse/CDS-499
//
// The optanonRequiredConsentCategories prop indicates the Optanon categories of
// the cookies that we need the user to accept. As an example, for YouTube videos,
// the cookie category is "C0005" (Social Media cookies)
//
// If the optanonRequiredConsentCategories prop is populated, then we
// apply a solution provided by OneTrust
//
// OneTrust References:
// https://my.onetrust.com/s/article/UUID-3dc06342-ff6b-3578-5024-6d7c05d03283?language=en_US
// https://my.onetrust.com/s/article/UUID-8102e851-d860-d465-d8d6-b1d636d68eb9
//
// Confluence reference:
// See https://confluence2.uk.rsa-ins.com/pages/viewpage.action?pageId=254315584
//
